<div class="tabs-header">
    <div class="left">
        <button
            (click)="select('overview')"
            [class.active]="selectedTab === 'overview'"
        >
            {{ "assetmanagement.tabs.overview" | transloco }}
        </button>
        <button
            (click)="select('assessments')"
            [class.active]="selectedTab === 'assessments'"
        >
            {{ "assetmanagement.tabs.assessments" | transloco }}
        </button>
    </div>
    <div class="right">
        <button
            (click)="select('linkedItems')"
            [class.active]="selectedTab === 'linkedItems'"
        >
            <mat-icon svgIcon="linked-items" />
        </button>
        <button
            (click)="select('documentandhyperlinks')"
            [class.active]="selectedTab === 'documentandhyperlinks'"
        >
            <mat-icon svgIcon="attachments" />
        </button>
        <button
            (click)="select('history')"
            [class.active]="selectedTab === 'history'"
        >
            <mat-icon svgIcon="history" />
        </button>
    </div>
</div>
